<!-- TODO: refactor this comp to itierate on LOV data -->
<div class="row" [ngClass]="{'invalid-input': invalidInput }">
  <div class="col" *ngIf="!visaUserLoggedIn">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="tourPackage" (change)="onCheckboxChange($event, TRAVEL_SERVICES.TOUR_PACKAGE)" [checked]="isChecked(TRAVEL_SERVICES.TOUR_PACKAGE)">
      <label for="tourPackage" class="checkbox-label">Tour Package</label>
    </div>
  </div>

  <div class="col" *ngIf="!visaUserLoggedIn">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="transportations" (change)="onCheckboxChange($event, TRAVEL_SERVICES.TRANSPORTATION)" [checked]="isChecked(TRAVEL_SERVICES.TRANSPORTATION)">
      <label for="transportations" class="checkbox-label">Transportations</label>
    </div>
  </div>

  <div class="col" *ngIf="!visaUserLoggedIn">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="hotels" (change)="onCheckboxChange($event, TRAVEL_SERVICES.HOTELS)" [checked]="isChecked(TRAVEL_SERVICES.HOTELS)">
      <label for="hotels" class="checkbox-label">Hotels</label>
    </div>
  </div>

  <div class="col" *ngIf="!visaUserLoggedIn">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="sightseeing" (change)="onCheckboxChange($event, TRAVEL_SERVICES.SIGHTSEEING)" [checked]="isChecked(TRAVEL_SERVICES.SIGHTSEEING)">
      <label for="sightseeing" class="checkbox-label">Sightseeing</label>
    </div>
  </div>

  <div class="col" *ngIf="!visaUserLoggedIn">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="transfers" (change)="onCheckboxChange($event, TRAVEL_SERVICES.TRANSFERS)" [checked]="isChecked(TRAVEL_SERVICES.TRANSFERS)">
      <label for="transfers" class="checkbox-label">Transfers</label>
    </div>
  </div>
  
    <div class="col" *ngIf="!hideVisaService && !hideVisa" [ngClass]="{'col-2':visaUserLoggedIn}" [ngStyle]="{ 'display': !clientUserLoggedIn ? 'block' : 'none' }">
      <div class="input-item">
        <input type="checkbox" [disabled]="disableServiceType" id="visa" (change)="onCheckboxChange($event, TRAVEL_SERVICES.VISA)" [checked]="isChecked(TRAVEL_SERVICES.VISA)">
        <label for="visa" class="checkbox-label">Visa</label>
      </div>
    </div>
</div>
